// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"faa490de","362":"d09e76fd"}[chunkId] + ".css";
};